export default __webpack_public_path__ + "static/identity2-f279f36ced8c28e08608601555fef8ba.jpg";